.container {
  font-size: 14px;
  border-bottom: 1px solid #d9d9d9;
  margin-bottom: 8px;
}

.label {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #595959;
  text-align: left;
  white-space: nowrap;
  margin-bottom: 8px;
}

.iconButton {
  min-height: 32px;
  min-width: 32px;
  padding: 4px;
}

.itemContainer {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-bottom: 8px;
}

.valueItemContainer {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-bottom: 8px;
  position: relative;
  max-height: calc(4 * 32px); /* 4 rows max: each row ~28px item + 4px gap */
  overflow: hidden;
}

.item {
  padding: 4px 8px;
  border-radius: 4px;
}

.badge {
  background-color: #f5f5f5;
  font-weight: 600;
  color: #595959;
}

.active {
  background-color: #f5f5f5;
  text-align: left;
}

.inactive {
  background-color: #ffd7d7;
}
